import React, { useEffect } from "react";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA1i(props) {
  const text = (props.entry && props.entry.text) || "";
  const imgUrl = (props.entry && props.entry.url) || "";

  const handleClick = () => {
    props.actions.sendMessageWithCode(props.entry.keyword, text);
    let imageWithButton = document.getElementsByClassName("ImageWithButton");
    for (let index = 0; index < imageWithButton.length; index++) {
      imageWithButton[index].style.pointerEvents = "none";
      imageWithButton[index].style.opacity = "0.5";
    }
  };
  const messageContainerStyle = () => {
    // let nextDiv = document.getElementById("ImageWithButtonId").nextSibling;

    return {
      opacity: props.disabled ? 0.5 : 1,
      pointerEvents: props.disabled ? 'none' : 'all',

      marginBottom: localStorage.getItem("openInFullScreen") ? '4%' : '2%',
      backgroundImage: `url(${imgUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      fontFamily: s360ConfigService?.config?.configDetails?.fontFamily
      // backgroundImage:
      // marginRight: document.getElementsByClassName("ImageWithButton").length >1 ? '7%':'50%'
    };
  };

  useEffect(() => {
    console.log(props, "a1i props");
    if (props.disabled) {
      let imageWithButton = document.getElementsByClassName("ImageWithButton");
      for (let index = 0; index < imageWithButton.length; index++) {
        imageWithButton[index].style.pointerEvents = "none";
        imageWithButton[index].style.opacity = "0.5";
      }
    }
  }, []);

  return (
    <div
      className="ImageWithButton"
      id="ImageWithButtonId"
      onClick={handleClick}
      style={messageContainerStyle()}
    >

      <p>{text}</p>
    </div>
  );
}

export default MessageA1i;
